import React, {useState,useEffect} from "react";
import './PC.css';
import Contain  from './Contain/Contain';

export default function PC() {
  const [CurrentIdName, setCurrentIdName] = useState("")
  const [contain, setContain] = useState("Enroll")

  useEffect(()=>{
    document.getElementById("Enroll").style.visibility = "hidden";
    setCurrentIdName("Enroll");
    //setContain("Enroll")
  },[])

  const click_ =(id_name)=>{
    document.getElementById(CurrentIdName).style.visibility = "visible";
    document.getElementById(id_name).style.visibility = "hidden";
    setCurrentIdName(id_name);
    setContain(id_name);
  }

  return (
    <div>
        <div className="PC-title">
          <h1>Playgrounds</h1>
        </div>

        <div className="PC-quick">

          <div className="PC-display">
          <div><h3>Enroll</h3><h2>注册</h2> </div>
          <div><h3>Login</h3><h2>登入</h2> </div>
          <div><h3>Puzzle</h3><h2>华容道</h2></div>
          <div><h3>AlbumS0</h3><h2>相册S0</h2></div>
          <div><h3>AlbumS1</h3><h2>相册S1</h2></div>
          <div><h3>AlbumS2</h3><h2>相册S2</h2></div>
          </div>

          <div className="PC-button">
          <div id="Enroll" onClick={()=>click_("Enroll")}><h3>Enroll</h3><h2>注册</h2> </div>
          <div id="Login" onClick={()=>click_("Login")}><h3>Login</h3><h2>登入</h2> </div>
          <div id="Puzzle" onClick={()=>click_("Puzzle")}><h3>Puzzle</h3><h2>华容道</h2></div>
          <div id="AlbumS0" onClick={()=>click_("AlbumS0")}><h3>AlbumS0</h3><h2>相册S0</h2></div>
          <div id="AlbumS1" onClick={()=>click_("AlbumS1")}><h3>AlbumS1</h3><h2>相册S1</h2></div>
          <div id="AlbumS2" onClick={()=>click_("AlbumS2")}><h3>AlbumS2</h3><h2>相册S2</h2></div>
          </div>

        </div>

        <div className="PC-contain">
          <Contain 
            ContainInfo = {contain}/>
        </div>

    </div>
  );
}

